import { styled } from '@mui/material/styles'
import { Box, Menu } from '@mui/material'

export const HeadingWrapper = styled(Box)(({ theme }) => (`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  height: 60px;
  background: ${theme.components.BreadCrumb.styleOverrides.background};
  transition: ${theme.transition};
  
  & p, & .buttonWrapper .menuButton {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 14px;
    color: ${theme.components.BreadCrumb.styleOverrides.color};
  }
  & .buttonWrapper .menuButton {
    padding: 0;
    & svg {
      margin-left: 5px;
    }
  }

`))

export const MenuWrapper = styled(Menu)(({ theme }) => (`
  & .MuiMenu-paper {
    margin-top:10px;
  }
  & ul {
    display: flex;
    flex-direction: column;
  }
  & ul * {
    display: block;
    width: 100%;
    text-align: left;
  }
`))
